"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalanceLogBalanceCell = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../utils/classFunctions");
const roundMoney_1 = require("../../../../utils/roundMoney");
require("./index.scss");
const className = 'balance-log-balance-cell';
const BalanceLogBalanceCell = (props) => {
    const { balance } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    const getDirection = () => {
        if (!balance)
            return undefined;
        if (balance < 0)
            return 'decrease';
        if (balance > 0)
            return 'increase';
        return undefined;
    };
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        getDirection(),
    ]);
    return (react_1.default.createElement("div", { className: classNames }, `${(0, roundMoney_1.localizeMoney)(balance, locale, 'Accounting/BalanceLog/BalanceLogBalanceCell')} CHF`));
};
exports.BalanceLogBalanceCell = BalanceLogBalanceCell;
//# sourceMappingURL=index.js.map